import { render } from "./MenuPane.vue?vue&type=template&id=240c5954&scoped=true"
import script from "./MenuPane.vue?vue&type=script&lang=js"
export * from "./MenuPane.vue?vue&type=script&lang=js"

import "./MenuPane.vue?vue&type=style&index=0&id=240c5954&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240c5954"]])

export default __exports__